import { GraphSchema } from '@camelot/server';

import { BillingItem, billingItemProps } from '../../../../common/services/dto/item';
import { DirectDebitStatus } from './direct-debit-status';
import { InvoiceStatus } from './invoice-status';
import { PaymentStatus } from './payment-status';
import { ProgressStatements } from './progress-statements';

export interface Invoice extends BillingItem {
  reference: string;
  externalReference: string;
  invoiceNumber: number;

  status: InvoiceStatus;
  paymentStatus: PaymentStatus;
  validationDate: string;

  progressStatements: ProgressStatements[];

  contactId: string;
  projectId: string;

  structuredCommunication: string;
  beneficiaryName: string;
  beneficiaryIban: string;
  beneficiaryBic: string;
  isCreditNote: boolean;

  hiddenDetails: boolean;

  directDebitStatus: DirectDebitStatus | null;
  directDebitStatusDate: string | null;

  documentIds: string[];
}

const props: (keyof Invoice)[] = [
  'reference',
  'externalReference',
  'validationDate',
  'invoiceNumber',
  'progressStatements',
  'contactId',
  'projectId',
  'paymentStatus',
  'isCreditNote',
  'structuredCommunication',
  'beneficiaryName',
  'beneficiaryIban',
  'beneficiaryBic',
  'status',
  'hiddenDetails',
  'directDebitStatus',
  'directDebitStatusDate',
  'documentIds',
];

export const invoiceProps = new GraphSchema<Invoice>(props.concat(billingItemProps));
